









import { computed, defineComponent, toRef, watch } from "@vue/composition-api";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { RecurringBillingScheduleSubjectTypeEnum } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import useBeforeUnloadTab from "@/hooks/useBeforeUnloadTab";
import { $t } from "@/lib/i18nHelpers";
import BaseSpinner from "@/components/BaseSpinner";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "PayPal",
  components: { BaseSpinner, ModalView },
  props: {
    show: { type: Boolean, required: true },
    processing: { type: Boolean, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    isSubscription: { type: Boolean, default: false },
    price: { type: String },
    purchaseSubject: { type: Object as () => Subject<ContentPriceSubjectTypeEnum> },
    subscriptionSubject: { type: Object as () => Subject<RecurringBillingScheduleSubjectTypeEnum> },
  },
  setup(props, { emit }) {
    useBeforeUnloadTab(
      $t("With closing browser tab funds could be billed from your credit card, but the purchase will not happened."),
      computed(() => !props.show)
    );

    watch(toRef(props, "show"), show => {
      if (show) {
        emit("submit", { purchaseSubject: props.purchaseSubject, subscriptionSubject: props.subscriptionSubject });
        emit("setCloseOnError", true);
      }
    });
  },
});
